import { Component, inject, input, model, output, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AllegatiService } from 'src/app/core/allegati.service';
import { DocumentiSearchDocRow, DocumentiSearchResultRow } from 'src/app/shared/models/documento-search.model';
import { DocumentoAllegato } from 'src/app/shared/models/documentoAllegato.model';

@Component({
  selector: 'app-partenza-riproduzione-dialog',
  template: `
  <p-dialog header="Gestione allegati da Riprodurre" [(visible)]="visible" [modal]="true" (onHide)="hideDialog()" >
  @if (riferimentiSearchResponse(); as riferimentiSearchResponse) {
    <div class="body-content" style="height:460px;">
      @switch (activeStepIndex()) {
        @case (0) {
        <div>
          <p style="font-weight: bold;">Selezionare il Documento da cui estrarre gli allegati</p>
          @for (riferimento of riferimentiSearchResponse; track riferimento.data.documentoId) {
          <div class="p-field-checkbox">
            <p-radioButton [inputId]="riferimento.data.protocollo" name="riferimento" [value]="riferimento" [(ngModel)]="selectedRiferimento">
            </p-radioButton>
            <label [for]="riferimento.data.protocollo">{{riferimento.data.protocollo}} del {{riferimento.data.dataDocumento  | date:'shortDate'}} - Mittente: {{riferimento.data.mittente}} Oggetto: {{riferimento.data.oggetto}}</label>
          </div>
          }
        </div>
        }
        @case (1) {
        <div>
          <p style="font-weight: bold;">Selezionare l'azione da effettuare per ogni allegato</p>
          <p-table [value]="allegati">
            <ng-template pTemplate="header">
                <tr>
                    <th>Riproduci</th>
                    <th>Nome del File</th>
                    <th>Dimensione</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-allegato let-i="rowIndex">
                <tr>
                  <td>
                  <div class="p-field-radiobutton">
                      <p-radioButton name="groupname_{{i}}" value="R" [(ngModel)]="selectedValues[i]" inputId="R"></p-radioButton>
                      <label for="R">Riproduci tutto</label>
                  </div>
                  <div class="p-field-radiobutton">
                      <p-radioButton name="groupname_{{i}}" value="T" [(ngModel)]="selectedValues[i]" inputId="T"></p-radioButton>
                      <label for="T">Trasmetti l'originale</label>
                  </div>
                  <div class="p-field-radiobutton">
                      <p-radioButton name="groupname_{{i}}" value="N" [(ngModel)]="selectedValues[i]" inputId="N"></p-radioButton>
                      <label for="N">Nessuna Azione</label>
                  </div>
                  </td>
                    <td>{{allegato.fileName}}</td>
                    <td>{{allegato.length}}</td>
                </tr>
            </ng-template>
         </p-table>
        </div>
        }
        @case (2) {
        <div>
          <p style="font-weight: bold;">Verificare l'azione da effettuare per ogni allegato<br>
          Protocollo Documento: {{riferimentoDoc!.protocollo}}</p>
          @for (allegato of allegati; track $index) {
          <li>{{allegato.fileName}} - {{azioneMapping(selectedValues[$index])}}</li>
          }
        </div>
        }
      }
    </div>
    <ng-template pTemplate="footer">
      <div class="grid">
        <div class="col-2">
          <button pButton type="button" [label]="labelIndietro" icon="fas fa-angle-left" class="p-button-secondary" (click)="previous()" [disabled]="disabledPrevious"></button>
        </div>
        <div class="col-8">
          <p-steps [model]="items" [(activeIndex)]="activeStepIndex"></p-steps>
        </div>
        <div class="col-2">
          <button pButton type="button" [label]="labelAvanti" icon="fas fa-angle-right" style="float: right" (click)="next()"></button>
        </div>
      </div>
    </ng-template>
  }
  </p-dialog>
  `,
  styles: [`
  :host ::ng-deep .p-dialog.p-component{
    width: 78vw;
  }

  :host ::ng-deep div.body-content {
    height: 460px;
  }

  .ui-steps .ui-steps-item {
    width: 25%;
  }

  .ui-steps.steps-custom {
    margin-bottom: 30px;
  }

  .ui-steps.steps-custom .ui-steps-item .ui-menuitem-link {
    height: 10px;
    padding: 0 1em;
  }

  .ui-steps.steps-custom .ui-steps-item .ui-steps-number {
    background-color: #0081c2;
    color: #FFFFFF;
    display: inline-block;
    width: 36px;
    border-radius: 50%;
    margin-top: -14px;
    margin-bottom: 10px;
  }

  .ui-steps.steps-custom .ui-steps-item .ui-steps-title {
    color: #555555;
  }
  `]
})

export class PartenzaRiproduzioneDialogComponent {
  visible = model.required<boolean>();
  riferimentiSearchResponse = input.required<DocumentiSearchResultRow[]>();
  hide = output();
  deleteFile = output<DocumentoAllegato>();
  showPassword = output<DocumentoAllegato>();
  changeRiproduzione = output<DocumentoAllegato>();

  public items: MenuItem[] = [
    { label: 'Riproduzione' },
    { label: 'Allegati' },
    { label: 'Riepilogo' }
  ];

  public allegati: DocumentoAllegato[] = [];
  public selectedValues: string[] = [];
  public activeStepIndex = signal(0);
  public selectedRiferimento: DocumentiSearchResultRow | undefined;
  public riferimentoDoc: DocumentiSearchDocRow | undefined;
  public disabledPrevious = true;
  public labelIndietro = 'Indietro';
  public labelAvanti = 'Avanti';

  private allegatiService = inject(AllegatiService);

  constructor() {
    // effect(() => {
    //   const riferimenti = this.riferimentiSearchResponse();
    //   if (riferimenti && riferimenti.length === 1) {
    //     this.selectedRiferimento = riferimenti[0];
    //     this.activeStepIndex.set(1);
    //     this.disabledPrevious = false;
    //     this.getAllegati();
    //   }
    // });
  }

  hideDialog(): void {
    this.labelAvanti = 'Avanti';
    this.labelIndietro = 'Indietro';
    this.disabledPrevious = true;
    this.activeStepIndex.set(0);
    this.hide.emit();
  }

  next(): void {
    switch (this.activeStepIndex()) {
      case 0:
        this.getAllegati();
        this.disabledPrevious = false;
        this.activeStepIndex.set(1);
        break;
      case 1:
        this.labelAvanti = 'Conferma';
        this.activeStepIndex.set(2);
        break;
      case 2:
        // todo call service logic

        this.hideDialog();
        break;
      default:
        break;
    }
  }

  previous(): void {
    switch (this.activeStepIndex()) {
      case 0:
        break;
      case 1:
        this.activeStepIndex.set(0);
        this.disabledPrevious = true;
        break;
      case 2:
        this.labelAvanti = 'Avanti';
        this.activeStepIndex.set(1);
        break;
      default:
        break;
    }
  }

  public azioneMapping(azione: string): string {
    switch (azione) {
      case 'N':
        return 'NESSUNA AZIONE'
      case 'R':
        return 'RIPRODUCI TUTTO'
      case 'T':
        return 'TRASMETTI L\'ORIGINALE'
      default:
        return 'NESSUNA AZIONE'
    }
  }

  private getAllegati(): void {
    if (!this.selectedRiferimento) return;

    this.riferimentoDoc = (this.selectedRiferimento.data as DocumentiSearchDocRow);
    this.allegatiService.getAllegati(this.riferimentoDoc.documentoId).subscribe(result => {
      this.allegati = result;
      this.selectedValues = new Array<string>(result.length).fill('N')
    });
  }
}
